import { DEFAULT_LOCALE, isSupportedLocale } from './app.js';
export const cashbookLabels = {
    en: {
        title: 'Cashbook',
        intro: 'Posted cash movements and physical counts. A count never creates a payment or journal entry.',
        account: 'Cash account',
        from: 'From',
        to: 'To',
        search: 'Search',
        opening: 'Opening balance',
        inflow: 'Inflow',
        outflow: 'Outflow',
        closing: 'Closing balance',
        balance: 'Balance',
        date: 'Date',
        reference: 'Reference',
        journal: 'Journal',
        empty: 'No cash movements in this period.',
        incomplete: 'Foreign currency evidence is incomplete. Review the original entries before counting.',
        negative: 'Negative cash balance on',
        count: 'Physical count',
        amount: 'Measured amount',
        reason: 'Reason or source',
        preview: 'Review count',
        book: 'Book balance',
        difference: 'Difference',
        save: 'Record count',
        history: 'Count history',
        changed: 'Book entries have changed since this count.',
        correction: 'Correct with a later reviewed count',
        export: 'Export CSV',
        previous: 'Previous',
        next: 'Next',
        sort: 'Reverse order',
        retry: 'Retry',
        loading: 'Loading',
        error: 'Could not load cashbook.',
        payment: 'Payments',
        transfer: 'Own transfers',
        manual: 'Manual journals',
        saved: 'Count recorded.',
        select: 'Select a cash account',
        noaccounts: 'No cash accounts are available.',
        source: 'Source',
        stale: 'The book changed. Review the count again.',
        historyOnly: 'Historical account: count history is available; new counts are disabled.',
        currency: 'Currency',
        revision: 'Revision',
        correctsRevision: 'Corrects revision',
        superseded: 'Superseded by revision',
        retainedNegative: 'Retained evidence: negative cash balance on',
        dateRange: 'The start date must be on or before the end date.',
    },
    de: {
        title: 'Kassenbuch',
        intro: 'Gebuchte Kassenbewegungen und Kassenstände. Eine Zählung erzeugt keine Zahlung oder Buchung.',
        account: 'Kassenkonto',
        from: 'Von',
        to: 'Bis',
        search: 'Suche',
        opening: 'Anfangsbestand',
        inflow: 'Zugang',
        outflow: 'Abgang',
        closing: 'Endbestand',
        balance: 'Bestand',
        date: 'Datum',
        reference: 'Referenz',
        journal: 'Buchung',
        empty: 'Keine Kassenbewegungen im Zeitraum.',
        incomplete: 'Fremdwährungsnachweise sind unvollständig. Prüfen Sie die ursprünglichen Buchungen vor der Zählung.',
        negative: 'Negativer Kassenbestand am',
        count: 'Kassenzählung',
        amount: 'Gezählter Betrag',
        reason: 'Grund oder Nachweis',
        preview: 'Zählung prüfen',
        book: 'Buchbestand',
        difference: 'Differenz',
        save: 'Zählung festhalten',
        history: 'Zählhistorie',
        changed: 'Buchungen haben sich seit dieser Zählung geändert.',
        correction: 'Durch eine spätere geprüfte Zählung korrigieren',
        export: 'CSV exportieren',
        previous: 'Zurück',
        next: 'Weiter',
        sort: 'Reihenfolge umkehren',
        retry: 'Erneut versuchen',
        loading: 'Wird geladen',
        error: 'Kassenbuch konnte nicht geladen werden.',
        payment: 'Zahlungen',
        transfer: 'Eigenüberträge',
        manual: 'Manuelle Buchungen',
        saved: 'Zählung erfasst.',
        select: 'Kassenkonto auswählen',
        noaccounts: 'Keine Kassenkonten vorhanden.',
        source: 'Quelle',
        stale: 'Der Buchbestand hat sich geändert. Prüfen Sie die Zählung erneut.',
        historyOnly: 'Historisches Konto: Die Zählhistorie ist verfügbar; neue Zählungen sind gesperrt.',
        currency: 'Währung',
        revision: 'Revision',
        correctsRevision: 'Korrigiert Revision',
        superseded: 'Ersetzt durch Revision',
        retainedNegative: 'Aufbewahrter Nachweis: negativer Kassenbestand am',
        dateRange: 'Das Anfangsdatum muss vor oder am Enddatum liegen.',
    },
    fr: {
        title: 'Livre de caisse',
        intro: 'Mouvements comptabilisés et comptages physiques. Un comptage ne crée aucun paiement ni écriture.',
        account: 'Compte de caisse',
        from: 'Du',
        to: 'Au',
        search: 'Rechercher',
        opening: 'Solde initial',
        inflow: 'Entrées',
        outflow: 'Sorties',
        closing: 'Solde final',
        balance: 'Solde',
        date: 'Date',
        reference: 'Référence',
        journal: 'Écriture',
        empty: 'Aucun mouvement sur cette période.',
        incomplete: 'Les justificatifs en devise sont incomplets. Vérifiez les écritures initiales avant le comptage.',
        negative: 'Solde négatif le',
        count: 'Comptage physique',
        amount: 'Montant compté',
        reason: 'Motif ou justificatif',
        preview: 'Vérifier le comptage',
        book: 'Solde comptable',
        difference: 'Écart',
        save: 'Enregistrer le comptage',
        history: 'Historique des comptages',
        changed: 'Les écritures ont changé depuis ce comptage.',
        correction: 'Corriger par un comptage ultérieur vérifié',
        export: 'Exporter CSV',
        previous: 'Précédent',
        next: 'Suivant',
        sort: 'Inverser l’ordre',
        retry: 'Réessayer',
        loading: 'Chargement',
        error: 'Impossible de charger le livre de caisse.',
        payment: 'Paiements',
        transfer: 'Virements internes',
        manual: 'Écritures manuelles',
        saved: 'Comptage enregistré.',
        select: 'Choisir un compte de caisse',
        noaccounts: 'Aucun compte de caisse disponible.',
        source: 'Source',
        stale: 'Le solde a changé. Vérifiez à nouveau le comptage.',
        historyOnly: 'Compte historique : l’historique reste disponible ; les nouveaux comptages sont désactivés.',
        currency: 'Devise',
        revision: 'Révision',
        correctsRevision: 'Corrige la révision',
        superseded: 'Remplacé par la révision',
        retainedNegative: 'Justificatif conservé : solde de caisse négatif le',
        dateRange: 'La date de début doit précéder la date de fin ou être identique.',
    },
    es: {
        title: 'Libro de caja',
        intro: 'Movimientos contabilizados y recuentos físicos. Un recuento no crea pagos ni asientos.',
        account: 'Cuenta de caja',
        from: 'Desde',
        to: 'Hasta',
        search: 'Buscar',
        opening: 'Saldo inicial',
        inflow: 'Entradas',
        outflow: 'Salidas',
        closing: 'Saldo final',
        balance: 'Saldo',
        date: 'Fecha',
        reference: 'Referencia',
        journal: 'Asiento',
        empty: 'No hay movimientos en este período.',
        incomplete: 'Faltan justificantes de moneda extranjera. Revise los asientos originales antes del recuento.',
        negative: 'Saldo negativo el',
        count: 'Recuento físico',
        amount: 'Importe contado',
        reason: 'Motivo o justificante',
        preview: 'Revisar recuento',
        book: 'Saldo contable',
        difference: 'Diferencia',
        save: 'Registrar recuento',
        history: 'Historial de recuentos',
        changed: 'Los asientos han cambiado desde este recuento.',
        correction: 'Corregir con un recuento posterior revisado',
        export: 'Exportar CSV',
        previous: 'Anterior',
        next: 'Siguiente',
        sort: 'Invertir orden',
        retry: 'Reintentar',
        loading: 'Cargando',
        error: 'No se pudo cargar el libro de caja.',
        payment: 'Pagos',
        transfer: 'Transferencias propias',
        manual: 'Asientos manuales',
        saved: 'Recuento registrado.',
        select: 'Seleccione una cuenta de caja',
        noaccounts: 'No hay cuentas de caja disponibles.',
        source: 'Origen',
        stale: 'El saldo ha cambiado. Revise de nuevo el recuento.',
        historyOnly: 'Cuenta histórica: el historial está disponible; no se pueden registrar nuevos recuentos.',
        currency: 'Moneda',
        revision: 'Revisión',
        correctsRevision: 'Corrige la revisión',
        superseded: 'Sustituido por la revisión',
        retainedNegative: 'Justificante conservado: saldo de caja negativo el',
        dateRange: 'La fecha inicial debe ser anterior o igual a la fecha final.',
    },
    tr: {
        title: 'Kasa defteri',
        intro: 'Kaydedilmiş kasa hareketleri ve fiziksel sayımlar. Sayım ödeme veya yevmiye kaydı oluşturmaz.',
        account: 'Kasa hesabı',
        from: 'Başlangıç',
        to: 'Bitiş',
        search: 'Ara',
        opening: 'Açılış bakiyesi',
        inflow: 'Giriş',
        outflow: 'Çıkış',
        closing: 'Kapanış bakiyesi',
        balance: 'Bakiye',
        date: 'Tarih',
        reference: 'Referans',
        journal: 'Yevmiye kaydı',
        empty: 'Bu dönemde kasa hareketi yok.',
        incomplete: 'Döviz kanıtları eksik. Sayımdan önce özgün kayıtları inceleyin.',
        negative: 'Negatif kasa bakiyesi tarihi',
        count: 'Fiziksel sayım',
        amount: 'Sayılan tutar',
        reason: 'Neden veya belge',
        preview: 'Sayımı incele',
        book: 'Defter bakiyesi',
        difference: 'Fark',
        save: 'Sayımı kaydet',
        history: 'Sayım geçmişi',
        changed: 'Bu sayımdan sonra defter kayıtları değişti.',
        correction: 'Daha sonraki incelenmiş sayımla düzelt',
        export: 'CSV dışa aktar',
        previous: 'Önceki',
        next: 'Sonraki',
        sort: 'Sıralamayı tersine çevir',
        retry: 'Yeniden dene',
        loading: 'Yükleniyor',
        error: 'Kasa defteri yüklenemedi.',
        payment: 'Ödemeler',
        transfer: 'Hesaplar arası aktarımlar',
        manual: 'Manuel kayıtlar',
        saved: 'Sayım kaydedildi.',
        select: 'Kasa hesabı seçin',
        noaccounts: 'Kasa hesabı bulunamadı.',
        source: 'Kaynak',
        stale: 'Defter değişti. Sayımı yeniden inceleyin.',
        historyOnly: 'Geçmiş hesap: sayım geçmişi kullanılabilir; yeni sayımlar kapalıdır.',
        currency: 'Para birimi',
        revision: 'Revizyon',
        correctsRevision: 'Düzeltilen revizyon',
        superseded: 'Yerine geçen revizyon',
        retainedNegative: 'Saklanan kanıt: negatif kasa bakiyesi tarihi',
        dateRange: 'Başlangıç tarihi bitiş tarihinden sonra olamaz.',
    },
};
export function cashbookText(language) {
    const locale = language.split('-')[0] ?? '';
    return cashbookLabels[isSupportedLocale(locale) ? locale : DEFAULT_LOCALE];
}
//# sourceMappingURL=ledger-cashbook-labels.js.map